import React, { createContext, useReducer } from "react";
import MediaReducer from "./MediaReducer";

const initialState = {
  player: null, //Video player reference
  slideNumber: 0,
  isFollowing: true,
};

export const MediaContext = createContext(initialState);

export const MediaProvider = ({ children }) => {
  const [state, dispatch] = useReducer(MediaReducer, initialState);

  //Actions
  //Set the video player
  function setPlayer(player) {
    dispatch({
      type: "SET_PLAYER",
      payload: player,
    });
  }

  function setSlideNumber(slideNumber) {
    dispatch({ type: "SET_SLIDE_NUMBER", payload: slideNumber });
  }

  function setVideoTs(videoTs) {
    state.player?.seekTo(videoTs);
  }

  function getVideoTs() {
    return Math.round(state.player.getCurrentTime());
  }

  function setIsFollowing(isFollowing) {
    dispatch({ type: "SET_IS_FOLLOWING", payload: isFollowing });
  }

  return (
    <MediaContext.Provider
      value={{
        player: state.player,
        slideNumber: state.slideNumber,
        setPlayer,
        getVideoTs,
        setVideoTs,
        setSlideNumber,
        setIsFollowing,
      }}
    >
      {children}
    </MediaContext.Provider>
  );
};
